import { createSignal } from "solid-js";
import { signalExtender } from "../../../utils/signal.js";
function createObject(value, options) {
    return createObject.wrap(createSignal(value, options));
}
createObject.wrap = (signal) => {
    return signalExtender(signal).extend(([state, setState]) => [
        {},
        {
            update(updates) {
                setState(() => ({
                    ...state(),
                    // TODO: typeof state() is AnyObject, correct this to T
                    ...(typeof updates === "function"
                        ? updates(state())
                        : updates),
                }));
                return state();
            },
            delete(property) {
                setState(({ [property]: _, ...remaining }) => remaining);
            },
        },
    ]);
};
export default createObject;
